"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Avatar.scss");
var _Paragraph = _interopRequireDefault(require("./Paragraph"));
var _Tooltip = _interopRequireDefault(require("./Tooltip"));
var _AvatarDemo = _interopRequireDefault(require("./assets/AvatarDemo1.svg"));
var _AvatarDemo2 = _interopRequireDefault(require("./assets/AvatarDemo2.svg"));
var _AvatarDemo3 = _interopRequireDefault(require("./assets/AvatarDemo3.svg"));
var _AvatarDemo4 = _interopRequireDefault(require("./assets/AvatarDemo4.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Avatar = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var avatar = _ref.avatar,
    altText = _ref.altText,
    role = _ref.role,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "large" : _ref$size,
    text = _ref.text;
  // Function to randomly select an avatar
  var getRandomAvatar = function getRandomAvatar() {
    var avatars = [_AvatarDemo["default"], _AvatarDemo2["default"], _AvatarDemo3["default"], _AvatarDemo4["default"]];
    var randomIndex = Math.floor(Math.random() * avatars.length);
    return avatars[randomIndex];
  };

  // Set avatar to a random demo if not provided
  var avatarSrc = avatar || getRandomAvatar();

  // Determine the size class
  var sizeClass = "avatar-".concat(size);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    delayDuration: 200
  }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"].Trigger, {
    asChild: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "avatar ".concat(sizeClass),
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: avatarSrc,
    alt: altText || "Avatar"
  }))), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"].Content, null, /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], {
    size: "medium"
  }, altText && altText, " ", role && role, " ", text && text))));
});
var _default = exports["default"] = Avatar;